import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createShiftType } from "../../actions/shiftTypeActions";
import Form from "./Form";
import Grid from "@material-ui/core/Grid";
import { TextField, FormControlLabel, Checkbox } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";

class CreateShiftTypeForm extends Component {
  state = {
    name: "",
    price: 0.0,
    isCardPhotoRequired: true,
  };

  createShiftType = (e) => {
    e.preventDefault();
    this.props
      .createShiftType(this.state)
      .then(() => (window.location.href = `/shifttype`));
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleCheckboxChange = (e) =>
    this.setState({ [e.target.name]: e.target.checked });

  handlePriceChange = (e) =>
    this.setState({ [e.target.name]: parseFloat(e.target.value).toFixed(2) });

  render() {
    return (
      <Form
        onSubmit={this.createShiftType}
        submitText="Toevoegen"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="name"
              name="name"
              label="Naam *"
              value={this.state.name}
              onChange={this.handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="price"
              name="price"
              type="number"
              label="Uurtarief *"
              value={this.state.price}
              onChange={this.handleChange}
              onBlur={this.handlePriceChange}
              fullWidth
              InputProps={{
                lang: "nl",
                min: ".01",
                step: ".01",
                startAdornment: (
                  <InputAdornment position="start">€</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  id="isCardPhotoRequired"
                  name="isCardPhotoRequired"
                  checked={this.state.isCardPhotoRequired}
                  onChange={this.handleCheckboxChange}
                />
              }
              label="Pas uploaden verplicht?"
            />
          </Grid>
        </Grid>
      </Form>
    );
  }
}

CreateShiftTypeForm.propTypes = {
  createShiftType: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.shifttype.createShiftType.successMessage,
  errorMessage: state.shifttype.createShiftType.errorMessage,
  isFetching: state.shifttype.createShiftType.isFetching,
});

export default connect(mapStateToProps, { createShiftType })(
  CreateShiftTypeForm,
);



// WEBPACK FOOTER //
// ./src/components/forms/CreateShiftTypeForm.js